import React from "react";
import { twMerge } from "tailwind-merge";
import Card from "../ui/Card";

/**
 * Quiet event/class list card shell — DemoLandingCard language.
 * Callers supply content; this owns border, radius, hover.
 */
export default function EventCard({
  children,
  className = "",
  featured = false,
  interactive = true,
  onClick,
  as: Tag = "article",
  ...rest
}) {
  return (
    <Tag className={twMerge("group relative", className)} {...rest}>
      <Card
        interactive={interactive && !onClick}
        className={twMerge(
          featured ? "p-5 sm:p-6" : "p-4 sm:p-5",
          onClick ? "quiet-card-interactive cursor-pointer" : "",
        )}
        onClick={onClick}
      >
        {children}
      </Card>
    </Tag>
  );
}

/** Shared meta line (date / eyebrow) */
export function EventCardMeta({ children, className = "" }) {
  return (
    <p className={twMerge("font-ui font-medium text-[12px] sm:text-[13px] text-ink/50 tracking-wide", className)}>
      {children}
    </p>
  );
}

/** In-app event title — Inter, not Playfair */
export function EventCardTitle({ children, featured = false, className = "" }) {
  return (
    <h3
      className={twMerge(
        "font-ui font-semibold text-ink text-balance leading-snug",
        featured ? "mt-1 text-[17px] sm:text-[18px]" : "mt-1 text-[15px] sm:text-[16px]",
        className,
      )}
    >
      {children}
    </h3>
  );
}

export function EventCardSubtitle({ children, className = "" }) {
  return (
    <p className={twMerge("mt-1 font-normal text-[13px] text-ink/55 text-pretty leading-relaxed line-clamp-2", className)}>
      {children}
    </p>
  );
}
